import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex mt-8 mb-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "d-flex align-center mr-6" }
const _hoisted_5 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { value: "延長保育日誌" }),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-6 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchValue.from,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue.from) = $event)),
                      label: "開始日",
                      "hide-details": "",
                      variant: "outlined",
                      density: "compact",
                      type: "date",
                      clearable: "",
                      disabled: _ctx.isLoading
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchValue.to,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue.to) = $event)),
                      label: "終了日",
                      "hide-details": "",
                      variant: "outlined",
                      density: "compact",
                      type: "date",
                      clearable: "",
                      disabled: _ctx.isLoading
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.listDiary,
                      color: "primary",
                      large: "",
                      variant: "flat",
                      loading: _ctx.isLoading
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("検索", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, "検索結果 " + _toDisplayString(_ctx.diaries.totalItemsCount) + "件", 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        to: "/nursery-hours-diary/edit"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" 新規作成 ", -1))
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diaries.diaries, (item, i) => {
      return (_openBlock(), _createBlock(_component_v_card, {
        key: i,
        class: "pa-3 my-2",
        variant: "outlined",
        style: {"border-color":"#e0e0e0"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", null, _toDisplayString(item.date), 1)
              ])
            ]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_4, [
              (item.approvedBy.chief && item.approvedBy.chief != -1)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: "primary",
                    class: "mx-1",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-check", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[6] || (_cache[6] = _createTextVNode(" 主任 ", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (item.approvedBy.director && item.approvedBy.director != -1)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 1,
                    color: "primary",
                    class: "mx-1",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-check", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[8] || (_cache[8] = _createTextVNode(" 施設長 ", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (item.status === 'applied')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 2,
                    color: "primary",
                    variant: "outlined",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("申請済み", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (item.status == 'draft')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 3,
                    variant: "outlined",
                    class: "mx-1",
                    style: {"border-color":"#e0e0e0"}
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("下書き ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                onClick: ($event: any) => (_ctx.clickEdit(item.nurseryHoursDiaryId, item.date)),
                color: "primary",
                variant: "flat",
                disabled: _ctx.isLoading
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("詳細", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}